import React from 'react';
import type { Error } from '../../../types/models/error';
import { ErrorItem } from './error-item';

interface ErrorsProps {
  errors: Array<Error>;
}

export function Errors(props: ErrorsProps) {
  return (
    <>
      {props.errors.map((e) => (
        <ErrorItem key={e.id} error={e} />
      ))}
    </>
  );
}
